(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-image-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let button = document.getElementById('dynamic-button');
    let spacer = document.getElementById('spacer');

    let observer = new IntersectionObserver(
      function (entries) {
        let isVisible = entries[0].isIntersecting;

        if (!isVisible && !button.classList.contains('sticky')) {
          button.classList.add('sticky');
          setTimeout(() => {
            button.classList.add('visible');
          }, 50); // Small delay for smooth appearance
        }

        if (isVisible && button.classList.contains('sticky')) {
          button.classList.remove('visible');

          setTimeout(() => {
            if (!button.classList.contains('visible')) {
              button.classList.remove('sticky');
            }
          }, 300); // Ensures smooth transition out
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(spacer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section-upgraded"] && !Shopify.designMode) return;
  try {
    
  // --- CAROUSEL CUSTOM ELEMENT ---
  if (!customElements.get('image-carousel')) {
    customElements.define(
      'image-carousel',
      class ImageCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = this.querySelectorAll('.carousel-slide');
          this.pills = this.querySelectorAll('.carousel-pill');
          if (this.slides.length <= 1) return;

          this.currentIndex = 0;
          this.intervalTime = parseInt(this.dataset.interval, 10) || 10000;
          this.timer = null;
          this.init();
        }

        init() {
          this.pills.forEach((pill) => {
            pill.addEventListener('click', (e) => {
              const targetIndex = parseInt(e.currentTarget.dataset.index, 10);
              if (!isNaN(targetIndex)) {
                this.goToSlide(targetIndex);
                this.resetTimer();
              }
            });
          });
          this.startTimer();
        }

        goToSlide(index) {
          if (index === this.currentIndex || index >= this.slides.length) return;

          const currentSlide = this.slides[this.currentIndex];
          const nextSlide = this.slides[index];
          const currentPill = this.pills[this.currentIndex];
          const nextPill = this.pills[index];

          if (currentSlide && nextSlide) {
            currentSlide.classList.remove('active');
            nextSlide.classList.add('active');
          }

          if (currentPill && nextPill) {
            currentPill.classList.remove('active');
            nextPill.classList.add('active');
          }

          this.currentIndex = index;
        }

        startTimer() {
          this.timer = setInterval(() => {
            const nextIndex = (this.currentIndex + 1) % this.slides.length;
            this.goToSlide(nextIndex);
          }, this.intervalTime);
        }

        resetTimer() {
          if (this.timer) {
            clearInterval(this.timer);
            this.startTimer();
          }
        }

        disconnectedCallback() {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      }
    );
  }

  // --- REVIEW SLIDES ROTATOR (RACE-CONDITION RESILIENT) ---
  const initReviews = () => {
    const slides = document.querySelectorAll('.review-slide');
    const progressBar = document.querySelector('.review-bar');

    if (slides.length > 1) {
      let index = 0;

      setInterval(() => {
        if (slides[index]) {
          slides[index].classList.remove('active');
        }
        index = (index + 1) % slides.length;
        if (slides[index]) {
          slides[index].classList.add('active');
        }

        if (progressBar) {
          progressBar.style.animation = 'none';
          progressBar.offsetHeight; /* Trigger reflow */
          progressBar.style.animation = 'loadBar 10s linear infinite';
        }
      }, 10000);
    }
  };

  // Run immediately or queue safely depending on state
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }

  } catch(e) { console.error(e); }
})();
})();
